import { render, staticRenderFns } from "./VacationContentComponent.vue?vue&type=template&id=5e3c2e28&scoped=true&"
import script from "./VacationContentComponent.vue?vue&type=script&lang=js&"
export * from "./VacationContentComponent.vue?vue&type=script&lang=js&"
import style0 from "./VacationContentComponent.vue?vue&type=style&index=0&id=5e3c2e28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3c2e28",
  null
  
)

export default component.exports